__turbopack_context__.v({
  "captions": "captions-module__Klx7iW__captions",
});
